import { render, staticRenderFns } from "./VeColorPicker.vue?vue&type=template&id=678b6342&scoped=true"
import script from "./VeColorPicker.vue?vue&type=script&lang=js"
export * from "./VeColorPicker.vue?vue&type=script&lang=js"
import style0 from "./VeColorPicker.vue?vue&type=style&index=0&id=678b6342&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b6342",
  null
  
)

export default component.exports